import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-skip-hydration',
  standalone: true,
  template: '<ng-content></ng-content>',
  host: {
    ngSkipHydration: '',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkipHydrationComponent {
}
